export enum LogLevel {
    All = 0,
    Debug = 1,
    Info = 2,
    Warn = 3,
    Error = 4,
    Fatal = 5,
    Off = 6,
}

export class LogEntry {
    /**
     * @var message - the log message
     */
    message = '';
    /**
     * @var level - the log level such as debug or error
     */
    level: LogLevel = LogLevel.Debug;
    /**
     * @var extraInfo - array of extra params that the user may need in the log
     */
    extraInfo: any[] = [];
    /**
     * @var logWithDate - boolean value based on which we add the date to the log
     */
    logWithDate = true;

    /**
     * Function used for building the log using information such as the type of the log or the date
     * @returns string - the log message formatted
     */
    buildLogString(): string {
        let ret = '';

        if (this.logWithDate) {
            ret = new Date() + ' - ';
        }

        ret += 'Type: ' + LogLevel[this.level];
        ret += ' - Message: ' + this.message;
        if (this.extraInfo.length) {
            ret += ' - Extra Info: ' + this.formatParams(this.extraInfo);
        }

        return ret;
    }

    /**
     * Function used for concatenating the array of extra params into a readable string for the log
     * @param params - array of extra data to be put in the log
     * @returns string - the formatted params into a readable string
     */
    private formatParams(params: any[]): string {
        let ret = params.join(',');

        // Is there at least one object in the array?
        if (params.some((p) => typeof p == 'object')) {
            ret = '';

            // Build comma-delimited string
            for (let item of params) {
                ret += JSON.stringify(item) + ',';
            }
        }

        return ret;
    }
}
